import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    buttonsContainer: {
        marginTop: theme.spacing(3),
        display: "flex",
        justifyContent: "flex-end",
    },
    deleteButton: {
        marginRight: theme.spacing(1),
    },
    tableContainer: {
        padding: theme.spacing(8, 0),
    },
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
    },
    alertContainer: {
        marginTop: theme.spacing(6),
    },
    boldText: {
        fontWeight: "bold",
    },
}));
